import hmap from 'hmap'

/**
 * 简单封装的hmap方法
 * 如果遇到接入不是4326坐标系的地图，可以使用setCrs进行设置，这样可以直接输入4326坐标系坐标得到其他坐标系的坐标
 */
export const mapUtil = {
  crs: 4326,
  /**
   * @param {Number|String} crs 坐标系rid
   */
  setCrs: function(crs) {
    this.crs = parseInt(crs)
  },
  /**
   * 坐标输出函数（经过坐标系转换）
   * @param {String|Number} lon 经度
   * @param {String|Number} lat 维度
   * @returns hmap.basetype.Coordinate 经过转换的坐标
   */
  coord: function(lon, lat, needToGCJ02 = false) {
    // 加密
    const newLonlat = needToGCJ02
      ? hmap.proj.Transformer.WGS84ToGCJ02([parseFloat(lon), parseFloat(lat)])
      : [parseFloat(lon), parseFloat(lat)]
    return hmap.proj.Transformer.transform(
      new hmap.basetype.Coordinate(newLonlat[0], newLonlat[1]),
      4326,
      this.crs
    )
  },
  size: (width, height) => new hmap.basetype.Size(width, height),
  offset: (x, y) => new hmap.basetype.Offset(parseFloat(x), parseFloat(y)),
  point: function(lon, lat) {
    return new hmap.geom.Point(this.coord(lon, lat))
  },
  icon: function(imgSrc, width = 30, height = 30) {
    return new hmap.style.Icon({
      imgSrc,
      size: this.size(width, height),
      anchor: [0.5, 1]
    })
  },
  vector: function(point, icon, attr = {}) {
    const vectorStyle = new hmap.style.Style({
      markerSymbols: [icon]
    })

    return new hmap.feature.Vector(point, attr, vectorStyle)
  },
  text: function(text, color, size, offset) {
    return new hmap.style.TextSymbol({
      text: text.toString(),
      fontSize: size,
      fontColor: new hmap.style.Color(0, 0, 0, 0.8),
      offset: this.offset(...offset)
    })
  },
  featureGeoJson(lon, lat, attr) {
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [parseFloat(lon), parseFloat(lat), 0]
      },
      properties: attr
    }
  }
}
